export default __webpack_public_path__ + "static/media/rp5.6a02e93e.jfif";